import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { coreSelectionsReducers } from './selections';

import { coreCustomersReducers, coreCustomersWatchers } from './customers';
import { coreDataDictionaryReducers, coreDataDictionaryWatchers } from './data-dictionary';
import { coreDataSecurityReducers, coreDataSecurityWatchers } from './data-security';
import { coreFollowersReducers, coreFollowersWatchers } from './followers';
import { coreInitiativesReducers, coreInitiativesWatchers } from './initiatives';
import { coreLegacyTimelineReducers, coreLegacyTimelineWatchers } from './timeline-legacy';
import { coreOnboardingReducers, coreOnboardingWatchers } from './onboarding';
import { coreOrganizationsReducers, coreOrganizationsWatchers } from './organizations';
import { coreSonarObjectsReducers, coreSonarObjectsWatchers } from './sonar-objects';
import { coreStakeholdersReducers, coreStakeholdersWatchers } from './stakeholders';
import { coreTagsReducers, coreTagsWatchers } from './tags';
import { coreTimelineReducers, coreTimelineWatchers } from './timeline';
import { coreUsersReducers, coreUsersWatchers } from './users';

export const coreReducers = combineReducers({
	customers: coreCustomersReducers,
	dataDictionary: coreDataDictionaryReducers,
	dataSecurity: coreDataSecurityReducers,
	followers: coreFollowersReducers,
	initiatives: coreInitiativesReducers,
	onboarding: coreOnboardingReducers,
	organizations: coreOrganizationsReducers,
	selections: coreSelectionsReducers,
	sonarObjects: coreSonarObjectsReducers,
	stakeholders: coreStakeholdersReducers,
	tags: coreTagsReducers,
	timeline: coreTimelineReducers,
	timelineLegacy: coreLegacyTimelineReducers,
	users: coreUsersReducers
});

export const coreWatchers = combineAllWatchers([
	coreCustomersWatchers,
	coreDataDictionaryWatchers,
	coreFollowersWatchers,
	coreInitiativesWatchers,
	coreOnboardingWatchers,
	coreOrganizationsWatchers,
	coreDataSecurityWatchers,
	coreSonarObjectsWatchers,
	coreStakeholdersWatchers,
	coreTagsWatchers,
	coreTimelineWatchers,
	coreLegacyTimelineWatchers,
	coreUsersWatchers
]);
